// src/services/supportTicketService.ts
import apiClient from "./apiClient";
import { toLegacyListResponse } from "../utils/normalizePaginatedResponse";

const SUPPORT_PATH = "tickets"; 

export const getSupportTickets = async (
  page = 1, 
  limit = 10,
  search = '', // New
  status = ''  // New
): Promise<any> => {
  try {
    const params: any = { page, limit };
    
    // Add search if present
    if (search) params.search = search;
    
    // Add status if it's not "All"
    if (status && status !== 'All') {
      params.status = status;
    }

      const response = await apiClient.get<any>(SUPPORT_PATH, { params });
      const legacy = toLegacyListResponse<unknown, "results">(response.data, "results");
      return {
        results: legacy.data.results,
        pagination: legacy.data.pagination,
        data: legacy.data,
      };
  } catch (error) {
    console.error("Failed to fetch support tickets:", error);
    throw error;
  }
};

export const updateSupportTicketStatus = async (
  ticketId: string,
  newStatus: string
): Promise<any> => {
  try {
    // API UpdateSupportTicketStatusDto expects `status` (PENDING | ANSWERED | CLOSED).
    const response = await apiClient.patch(`${SUPPORT_PATH}/${ticketId}/status`, {
      status: newStatus,
    });
    return response.data;
  } catch (error) {
    console.error(`Failed to update status for ticket ${ticketId}:`, error);
    throw error;
  }
};